import { makeStyles } from '@material-ui/core';
import { priorityPopoverStyles } from 'common/components/AdvancedSearch/AdvancedSearch.styled';

import { filterBaseStyles } from '../Filters/Filters.styled';

export const useStyles = makeStyles(
  theme => ({
    ...filterBaseStyles(theme),
    ...priorityPopoverStyles(theme),
    chipContainer: {
      marginTop: theme.spacing(1)
    }
  }),
  { name: 'CollapsibleChipFilter' }
);
